<template>
  <div class="album column is-2-desktop is-3-tablet is-6-mobile">
    <multi-album-cover
      v-bind:albums="albums"
      v-on:click="play"
      class="album-cover poly-cursor-pointer"
    >
      <span class="state-icon icon is-large is-overlay has-text-black poly-hidden poly-visible-touch">
        <i class="mdi mdi-24px mdi-shuffle"></i>
      </span>
    </multi-album-cover>

    <dl style="margin-top:0.4rem;">
      <dd class="album-name has-text-weight-bold poly-truncate">
        Your most played songs
      </dd>

      <dd class="album-artist has-text-grey-light has-text-weight-semibold poly-truncate">
      </dd>
    </dl>
  </div>
</template>

<script>
  import MultiAlbumCover from '@/components/MultiAlbumCover'

  import shuffleArray from '@/mixins/shuffleArray'

  export default {
    name: 'MostPlayedTracks',
    mixins: [shuffleArray],
    components: {
      MultiAlbumCover
    },
    props: {
      tracks: {
        type: Array,
        required: true
      }
    },
    computed: {
      albums: function () {
        return this.tracks.map(
          (track) => { return track.album }
        )
      }
    },
    methods: {
      play: function () {
        this.fetchTracks().then((response) => {
          if (!response.data.tracks.length) return

          var shuffledTracksToPlay = this.shuffleArray(response.data.tracks)

          if (this.$store.getters.currentTrack && shuffledTracksToPlay.length > 1) {
            while (shuffledTracksToPlay[0].id === this.$store.getters.currentTrack.id) {
              shuffledTracksToPlay = this.shuffleArray(shuffledTracksToPlay)
            }
          }

          this.$store.commit('playTracks', { tracks: shuffledTracksToPlay })
        }).catch(() => {
          console.error('There was an error trying to get most played tracks')
        })
      },
      fetchTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/MostPlayedTracks.gql'),
          fetchPolicy: 'no-cache'
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .album { padding-bottom: 0.2rem !important; }
  .album-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .album-cover:hover .state-icon { visibility: visible; }
  .album-artist { font-size: 0.85rem; margin-top: -0.16rem; }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .album-name { font-size: 0.9rem; }
    .state-icon {
      margin-left: 0.3rem;
      margin-bottom: 0.3rem;
      transform: scale(0.8);
    }
  }
</style>
